<div class="currencies-price-update-button">
  <span>{{ 'currencies.price-validity' | translate : { date: date | localizedDate : 'medium' } }}</span>
  <app-action-button
    [label]="'shared.common.update'"
    [facet]="'secondary-link'"
    [size]="'small'"
    [appearance]="'font-normal'"
  ></app-action-button>
</div>
